<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input-facade
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      masked
      mask="###-###-### ##"
      placeholder="123-456-789 01"
      maxlength="14"
      class="form-control text-uppercase"
      @change="emitValue('change', $event)"
      @input="emitValue('input', $event)"
      @blur="emitValue('blur', $event)"
      @keydown="emit"
      @keyup="emit"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorSnilsInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'СНИЛС'
    },

    inputName: {
      default: 'snils'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId () {
      return `form-visitor-snils-${this.visitorIndex}`
    }
  }
}
</script>
